// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"26f8f26f","453":"c3b43861","583":"e1f80d36"}[chunkId] + ".chunk.js";
};